import { VStack, type ChakraProps, useBreakpointValue } from '@chakra-ui/react';
import type { ReactNode } from 'react';

export function BaseAuthCard({ children }: { children: ReactNode }) {
  const mediaProps = useBreakpointValue<Partial<ChakraProps>>({
    base: { height: 'unset', overflowY: 'unset' },
    lg: { height: 'full', overflowY: 'auto' },
  });

  return (
    <VStack align='stretch' spacing={0} width='100%' {...mediaProps}>
      {children}
    </VStack>
  );
}
